// extracted by mini-css-extract-plugin
export default {"cls1":"Comments-cls1_DSz","cls2":"Comments-cls2_yFU Comments-cls1_DSz"};